import { CSSProperties, ReactNode, useEffect, useState } from 'react';
import { useSortable } from '@dnd-kit/sortable';
import { DndItem } from '../DndItem';

type SortableItemProps = {
  id: string;
  values?: any;
  handle?: boolean;
  showHandler?: boolean;
  disabled?: boolean;
  renderItem?: () => React.ReactElement;
  children?: ReactNode;
  extra?: ReactNode;
};
export const SortableItem = ({
  id,
  values,
  handle,
  showHandler,
  disabled,
  renderItem,
  children,
  extra,
}: SortableItemProps) => {
  const {
    setNodeRef,
    listeners,
    isDragging,
    isSorting,
    // over,
    // overIndex,
    transform,
    transition,
  } = useSortable({
    id,
    data: {
      type: 'row',
      values,
    },
  });
  const mounted = useMountStatus();
  const mountedWhileDragging = isDragging && !mounted;
  return (
    <DndItem
      ref={disabled ? undefined : setNodeRef}
      dragging={isDragging}
      sorting={isSorting}
      handle={handle}
      showHandler={showHandler}
      transition={transition}
      transform={transform}
      fadeIn={mountedWhileDragging}
      listeners={listeners}
      extra={extra}
    >
      {children}
    </DndItem>
  );
};

export interface Props {
  style?: CSSProperties;
  isDragOverlay?: boolean;
  isDragging?: boolean;
  children: ReactNode;
}

function useMountStatus() {
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => setIsMounted(true), 500);

    return () => clearTimeout(timeout);
  }, []);

  return isMounted;
}
